'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var transport = require('@onekeyfe/hd-transport');
var hdShared = require('@onekeyfe/hd-shared');
var ByteBuffer = require('bytebuffer');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var transport__default = /*#__PURE__*/_interopDefaultLegacy(transport);
var ByteBuffer__default = /*#__PURE__*/_interopDefaultLegacy(ByteBuffer);

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

const { parseConfigure: parseConfigure$1, buildEncodeBuffers, decodeProtocol, receiveOne: receiveOne$1, check: check$1 } = transport__default["default"];
const CONFIGURATION_ID = 1;
const INTERFACE_ID = 0;
const ENDPOINT_ID = 1;
const PACKET_SIZE = 64;
const HEADER_LENGTH = 6;
const PACKET_IO_MAX_RETRIES = 3;
const PACKET_IO_RETRY_DELAY = 300;
class WebUsbTransport {
    constructor() {
        this.name = 'WebUsbTransport';
        this.stopped = false;
        this.configured = false;
        this.deviceList = [];
        this.configurationId = CONFIGURATION_ID;
        this.endpointId = ENDPOINT_ID;
        this.interfaceId = INTERFACE_ID;
    }
    init(logger) {
        this.Log = logger;
        const { usb } = navigator;
        if (!usb) {
            throw hdShared.ERRORS.TypedError(hdShared.HardwareErrorCode.RuntimeError, 'WebUSB is not supported by current browsers');
        }
        this.usb = usb;
    }
    configure(signedData) {
        const messages = parseConfigure$1(signedData);
        this.configured = true;
        this.messages = messages;
    }
    promptDeviceAccess() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.usb)
                return null;
            try {
                const device = yield this.usb.requestDevice({ filters: hdShared.ONEKEY_WEBUSB_FILTER });
                return device;
            }
            catch (e) {
                this.Log.debug('requestDevice error: ', e);
                return null;
            }
        });
    }
    enumerate() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.getConnectedDevices();
            return this.deviceList;
        });
    }
    getConnectedDevices() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.usb)
                return [];
            const devices = yield this.usb.getDevices();
            const onekeyDevices = devices.filter(dev => {
                const isOneKey = hdShared.ONEKEY_WEBUSB_FILTER.some(desc => dev.vendorId === desc.vendorId && dev.productId === desc.productId);
                const hasSerialNumber = typeof dev.serialNumber === 'string' && dev.serialNumber.length > 0;
                return isOneKey && hasSerialNumber;
            });
            this.deviceList = onekeyDevices.map(device => ({
                path: device.serialNumber,
                device,
                commType: 'webusb',
            }));
            return this.deviceList;
        });
    }
    acquire(input) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            if (!input.path)
                return;
            try {
                yield this.connect((_a = input.path) !== null && _a !== void 0 ? _a : '', true);
                return yield Promise.resolve(input.path);
            }
            catch (e) {
                this.Log.debug('acquire error: ', e);
                throw e;
            }
        });
    }
    findDevice(path) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.deviceList.length === 0) {
                yield this.getConnectedDevices();
            }
            let device = this.deviceList.find(d => d.path === path);
            if (device == null) {
                yield this.getConnectedDevices();
                device = this.deviceList.find(d => d.path === path);
                if (device == null) {
                    throw new Error('Action was interrupted.');
                }
            }
            return device.device;
        });
    }
    connect(path, first) {
        return __awaiter(this, void 0, void 0, function* () {
            const maxRetries = 5;
            for (let i = 0; i < maxRetries; i++) {
                try {
                    return yield this.connectToDevice(path, first);
                }
                catch (e) {
                    if (i === maxRetries - 1) {
                        throw e;
                    }
                    yield hdShared.wait(i * 200);
                }
            }
        });
    }
    connectToDevice(path, first) {
        return __awaiter(this, void 0, void 0, function* () {
            const device = yield this.findDevice(path);
            yield device.open();
            if (first) {
                yield device.selectConfiguration(this.configurationId);
                try {
                    yield device.reset();
                }
                catch (error) {
                }
            }
            yield device.claimInterface(this.interfaceId);
        });
    }
    post(session, name, data) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.call(session, name, data);
        });
    }
    getErrorMessage(error) {
        if (!error)
            return '';
        if (typeof error === 'string')
            return error;
        if (typeof error === 'object' && 'message' in error) {
            const { message } = error;
            return typeof message === 'string' ? message : String(message !== null && message !== void 0 ? message : '');
        }
        return String(error);
    }
    isRetryablePacketIoError(error) {
        const message = this.getErrorMessage(error).toLowerCase();
        return (message.includes('transferout') ||
            message.includes('transferin') ||
            message.includes('usbdevice') ||
            message.includes('disconnected') ||
            message.includes('device not found') ||
            message.includes('action was interrupted') ||
            message.includes('networkerror'));
    }
    reconnectForPacketIoRetry(path, direction, attempt, error) {
        return __awaiter(this, void 0, void 0, function* () {
            this.Log.debug(`[WebUsbTransport] transfer${direction} failed, retry ${attempt}/${PACKET_IO_MAX_RETRIES}: ${this.getErrorMessage(error)}`);
            yield hdShared.wait(attempt * PACKET_IO_RETRY_DELAY);
            try {
                const currentDevice = yield this.findDevice(path);
                if (currentDevice.opened) {
                    try {
                        yield currentDevice.releaseInterface(this.interfaceId);
                    }
                    catch (releaseError) {
                        this.Log.debug('[WebUsbTransport] releaseInterface before retry error:', releaseError);
                    }
                    yield currentDevice.close();
                }
            }
            catch (closeError) {
                this.Log.debug('[WebUsbTransport] close device before retry error:', closeError);
            }
            yield this.getConnectedDevices();
            yield this.connect(path, false);
        });
    }
    getTransferInData(result) {
        if (result.status !== 'ok') {
            throw new Error(`transferIn status: ${String(result.status)}`);
        }
        if (!result.data || result.data.byteLength === 0) {
            throw new Error('transferIn no data');
        }
        return result.data;
    }
    toArrayBuffer(buffer) {
        if (buffer instanceof ArrayBuffer) {
            return buffer;
        }
        const copied = new Uint8Array(buffer.byteLength);
        copied.set(new Uint8Array(buffer));
        return copied.buffer;
    }
    transferOutWithRetry(path, packet) {
        return __awaiter(this, void 0, void 0, function* () {
            let lastError;
            for (let attempt = 1; attempt <= PACKET_IO_MAX_RETRIES; attempt += 1) {
                try {
                    const device = yield this.findDevice(path);
                    if (!device.opened) {
                        yield this.connect(path, false);
                    }
                    const transferBuffer = this.toArrayBuffer(packet.buffer.slice(packet.byteOffset, packet.byteOffset + packet.byteLength));
                    yield device.transferOut(this.endpointId, transferBuffer);
                    return;
                }
                catch (error) {
                    lastError = error;
                    const shouldRetry = attempt < PACKET_IO_MAX_RETRIES && this.isRetryablePacketIoError(error);
                    if (!shouldRetry) {
                        throw error;
                    }
                    try {
                        yield this.reconnectForPacketIoRetry(path, 'out', attempt, error);
                    }
                    catch (reconnectError) {
                        lastError = reconnectError;
                        this.Log.debug(`[WebUsbTransport] transferout reconnect failed on retry ${attempt}/${PACKET_IO_MAX_RETRIES}: ${this.getErrorMessage(reconnectError)}`);
                    }
                }
            }
            throw lastError;
        });
    }
    transferInWithRetry(path, length) {
        return __awaiter(this, void 0, void 0, function* () {
            let lastError;
            for (let attempt = 1; attempt <= PACKET_IO_MAX_RETRIES; attempt += 1) {
                try {
                    const device = yield this.findDevice(path);
                    if (!device.opened) {
                        yield this.connect(path, false);
                    }
                    const result = yield device.transferIn(this.endpointId, length);
                    return this.getTransferInData(result);
                }
                catch (error) {
                    lastError = error;
                    const shouldRetry = attempt < PACKET_IO_MAX_RETRIES && this.isRetryablePacketIoError(error);
                    if (!shouldRetry) {
                        throw error;
                    }
                    try {
                        yield this.reconnectForPacketIoRetry(path, 'in', attempt, error);
                    }
                    catch (reconnectError) {
                        lastError = reconnectError;
                        this.Log.debug(`[WebUsbTransport] transferin reconnect failed on retry ${attempt}/${PACKET_IO_MAX_RETRIES}: ${this.getErrorMessage(reconnectError)}`);
                    }
                }
            }
            throw lastError;
        });
    }
    call(path, name, data) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.messages == null) {
                throw hdShared.ERRORS.TypedError(hdShared.HardwareErrorCode.TransportNotConfigured);
            }
            const device = yield this.findDevice(path);
            if (!device) {
                throw hdShared.ERRORS.TypedError(hdShared.HardwareErrorCode.DeviceNotFound);
            }
            const { messages } = this;
            if (transport.LogBlockCommand.has(name)) {
                this.Log.debug('call-', ' name: ', name);
            }
            else {
                this.Log.debug('call-', ' name: ', name, ' data: ', data);
            }
            const encodeBuffers = buildEncodeBuffers(messages, name, data);
            for (const buffer of encodeBuffers) {
                const newArray = new Uint8Array(PACKET_SIZE);
                newArray[0] = 63;
                newArray.set(new Uint8Array(buffer), 1);
                yield this.transferOutWithRetry(path, newArray);
            }
            const resData = yield this.receiveData(path);
            if (typeof resData !== 'string') {
                throw hdShared.ERRORS.TypedError(hdShared.HardwareErrorCode.NetworkError, 'Returning data is not string.');
            }
            const jsonData = receiveOne$1(messages, resData);
            return check$1.call(jsonData);
        });
    }
    receiveData(path) {
        return __awaiter(this, void 0, void 0, function* () {
            const firstPacketData = yield this.transferInWithRetry(path, PACKET_SIZE);
            const firstData = this.toArrayBuffer(firstPacketData.buffer.slice(1));
            const { length, typeId, restBuffer } = decodeProtocol.decodeChunked(firstData);
            const lengthWithHeader = Number(length + HEADER_LENGTH);
            const decoded = new ByteBuffer__default["default"](lengthWithHeader);
            decoded.writeUint16(typeId);
            decoded.writeUint32(length);
            if (length) {
                decoded.append(restBuffer);
            }
            while (decoded.offset < lengthWithHeader) {
                const packetData = yield this.transferInWithRetry(path, PACKET_SIZE);
                const buffer = this.toArrayBuffer(packetData.buffer.slice(1));
                if (lengthWithHeader - decoded.offset >= PACKET_SIZE) {
                    decoded.append(buffer);
                }
                else {
                    decoded.append(buffer.slice(0, lengthWithHeader - decoded.offset));
                }
            }
            decoded.reset();
            const result = decoded.toBuffer();
            return Buffer.from(result).toString('hex');
        });
    }
    release(path) {
        return __awaiter(this, void 0, void 0, function* () {
            const device = yield this.findDevice(path);
            yield device.releaseInterface(this.interfaceId);
            yield device.close();
        });
    }
}

const { parseConfigure, buildBuffers, receiveOne, check } = transport__default["default"];
class ElectronBleTransport {
    constructor() {
        this.name = 'ElectronBleTransport';
        this.configured = false;
        this.runPromise = null;
        this.connectedDevices = new Set();
        this.dataBuffers = new Map();
        this.notificationCleanups = new Map();
        this.disconnectCleanups = new Map();
    }
    handleBluetoothError(error) {
        if (error && typeof error === 'object') {
            if ('code' in error) {
                if (error.code === hdShared.HardwareErrorCode.BlePoweredOff) {
                    throw hdShared.ERRORS.TypedError(hdShared.HardwareErrorCode.BlePoweredOff);
                }
                if (error.code === hdShared.HardwareErrorCode.BleUnsupported) {
                    throw hdShared.ERRORS.TypedError(hdShared.HardwareErrorCode.BleUnsupported);
                }
                if (error.code === hdShared.HardwareErrorCode.BlePermissionError) {
                    throw hdShared.ERRORS.TypedError(hdShared.HardwareErrorCode.BlePermissionError);
                }
            }
            const errorMessage = error.message || String(error);
            const poweredOffMessage = hdShared.HardwareErrorCodeMessage[hdShared.HardwareErrorCode.BlePoweredOff];
            const unsupportedMessage = hdShared.HardwareErrorCodeMessage[hdShared.HardwareErrorCode.BleUnsupported];
            const permissionMessage = hdShared.HardwareErrorCodeMessage[hdShared.HardwareErrorCode.BlePermissionError];
            if (errorMessage.includes(poweredOffMessage) || errorMessage.includes('poweredOff')) {
                throw hdShared.ERRORS.TypedError(hdShared.HardwareErrorCode.BlePoweredOff);
            }
            if (errorMessage.includes(unsupportedMessage) || errorMessage.includes('unsupported')) {
                throw hdShared.ERRORS.TypedError(hdShared.HardwareErrorCode.BleUnsupported);
            }
            if (errorMessage.includes(permissionMessage) || errorMessage.includes('unauthorized')) {
                throw hdShared.ERRORS.TypedError(hdShared.HardwareErrorCode.BlePermissionError);
            }
        }
        throw error;
    }
    cleanupDeviceState(deviceId) {
        this.connectedDevices.delete(deviceId);
        this.dataBuffers.delete(deviceId);
        const notifyCleanup = this.notificationCleanups.get(deviceId);
        if (notifyCleanup) {
            notifyCleanup();
            this.notificationCleanups.delete(deviceId);
        }
        const disconnectCleanup = this.disconnectCleanups.get(deviceId);
        if (disconnectCleanup) {
            disconnectCleanup();
            this.disconnectCleanups.delete(deviceId);
        }
    }
    init(logger, emitter) {
        var _a, _b;
        this.Log = logger;
        this.emitter = emitter;
        if (!((_a = window.desktopApi) === null || _a === void 0 ? void 0 : _a.nobleBle)) {
            throw hdShared.ERRORS.TypedError(hdShared.HardwareErrorCode.RuntimeError, 'Noble BLE API is not available. Please ensure you are running in Electron with Noble support.');
        }
        (_b = this.Log) === null || _b === void 0 ? void 0 : _b.debug('[Transport] Noble BLE Transport initialized');
    }
    configure(signedData) {
        const messages = parseConfigure(signedData);
        this.configured = true;
        this._messages = messages;
    }
    listen() { }
    enumerate() {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (!((_a = window.desktopApi) === null || _a === void 0 ? void 0 : _a.nobleBle)) {
                    throw new Error('Noble BLE API not available');
                }
                const devices = yield window.desktopApi.nobleBle.enumerate();
                return devices;
            }
            catch (error) {
                (_b = this.Log) === null || _b === void 0 ? void 0 : _b.error('[Transport] Noble BLE enumerate failed:', error);
                this.handleBluetoothError(error);
            }
        });
    }
    acquire(input) {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function* () {
            const { uuid, forceCleanRunPromise } = input;
            if (!uuid) {
                throw hdShared.ERRORS.TypedError(hdShared.HardwareErrorCode.BleRequiredUUID);
            }
            if (forceCleanRunPromise && this.runPromise) {
                this.runPromise.reject(hdShared.ERRORS.TypedError(hdShared.HardwareErrorCode.BleForceCleanRunPromise));
            }
            try {
                if (!((_a = window.desktopApi) === null || _a === void 0 ? void 0 : _a.nobleBle)) {
                    throw new Error('Noble BLE API not available');
                }
                const device = yield window.desktopApi.nobleBle.getDevice(uuid);
                if (!device) {
                    throw hdShared.ERRORS.TypedError(hdShared.HardwareErrorCode.DeviceNotFound, `Device ${uuid} not found`);
                }
                try {
                    yield window.desktopApi.nobleBle.connect(uuid);
                    this.connectedDevices.add(uuid);
                }
                catch (error) {
                    this.handleBluetoothError(error);
                }
                this.dataBuffers.set(uuid, { buffer: [], bufferLength: 0 });
                yield window.desktopApi.nobleBle.subscribe(uuid);
                const cleanup = window.desktopApi.nobleBle.onNotification((deviceId, data) => {
                    if (deviceId === uuid) {
                        this.handleNotificationData(uuid, data);
                    }
                });
                this.notificationCleanups.set(uuid, cleanup);
                const disconnectCleanup = window.desktopApi.nobleBle.onDeviceDisconnected((disconnectedDevice) => {
                    var _a;
                    if (disconnectedDevice.id === uuid) {
                        this.cleanupDeviceState(uuid);
                        (_a = this.emitter) === null || _a === void 0 ? void 0 : _a.emit('device-disconnect', {
                            name: disconnectedDevice.name,
                            id: disconnectedDevice.id,
                            connectId: disconnectedDevice.id,
                        });
                    }
                });
                this.disconnectCleanups.set(uuid, disconnectCleanup);
                (_b = this.emitter) === null || _b === void 0 ? void 0 : _b.emit('device-connect', {
                    name: device.name,
                    id: device.id,
                    connectId: device.id,
                });
                return { uuid, path: uuid };
            }
            catch (error) {
                (_c = this.Log) === null || _c === void 0 ? void 0 : _c.error('[Transport] Noble BLE acquire failed:', error);
                throw error;
            }
        });
    }
    release(id) {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (this.connectedDevices.has(id)) {
                    if ((_a = window.desktopApi) === null || _a === void 0 ? void 0 : _a.nobleBle) {
                        yield window.desktopApi.nobleBle.unsubscribe(id);
                    }
                    if ((_b = window.desktopApi) === null || _b === void 0 ? void 0 : _b.nobleBle) {
                        yield window.desktopApi.nobleBle.disconnect(id);
                    }
                    this.cleanupDeviceState(id);
                }
            }
            catch (error) {
                (_c = this.Log) === null || _c === void 0 ? void 0 : _c.error('[Transport] Noble BLE release failed:', error);
                this.cleanupDeviceState(id);
            }
        });
    }
    handleNotificationData(deviceId, hexData) {
        var _a, _b;
        if (hexData === 'PAIRING_REJECTED') {
            (_a = this.Log) === null || _a === void 0 ? void 0 : _a.debug('[Transport] Pairing rejection detected for device:', deviceId);
            if (this.runPromise) {
                this.runPromise.reject(hdShared.ERRORS.TypedError(hdShared.HardwareErrorCode.BleDeviceBondedCanceled));
            }
            return;
        }
        const result = this.processNotificationPacket(deviceId, hexData);
        if (result.error) {
            (_b = this.Log) === null || _b === void 0 ? void 0 : _b.error('[Transport] Packet processing error:', result.error);
            if (this.runPromise) {
                this.runPromise.reject(hdShared.ERRORS.TypedError(hdShared.HardwareErrorCode.BleWriteCharacteristicError));
            }
            return;
        }
        if (result.isComplete && result.completePacket) {
            if (this.runPromise) {
                this.runPromise.resolve(result.completePacket);
            }
        }
    }
    call(uuid, name, data) {
        var _a, _b, _c, _d, _e, _f, _g;
        return __awaiter(this, void 0, void 0, function* () {
            if (this._messages == null) {
                throw hdShared.ERRORS.TypedError(hdShared.HardwareErrorCode.TransportNotConfigured);
            }
            const forceRun = name === 'Initialize' || name === 'Cancel';
            if (this.runPromise && !forceRun) {
                throw hdShared.ERRORS.TypedError(hdShared.HardwareErrorCode.TransportCallInProgress);
            }
            if (!this.connectedDevices.has(uuid)) {
                throw hdShared.ERRORS.TypedError(hdShared.HardwareErrorCode.TransportNotFound, `Device ${uuid} not connected`);
            }
            this.runPromise = hdShared.createDeferred();
            const messages = this._messages;
            if (name === 'ResourceUpdate' || name === 'ResourceAck') {
                (_a = this.Log) === null || _a === void 0 ? void 0 : _a.debug('[Transport] Noble BLE call', 'name:', name, 'data:', {
                    file_name: data === null || data === void 0 ? void 0 : data.file_name,
                    hash: data === null || data === void 0 ? void 0 : data.hash,
                });
            }
            else if (transport.LogBlockCommand.has(name)) {
                (_b = this.Log) === null || _b === void 0 ? void 0 : _b.debug('[Transport] Noble BLE call', 'name:', name);
            }
            else {
                (_c = this.Log) === null || _c === void 0 ? void 0 : _c.debug('[Transport] Noble BLE call', 'name:', name, 'data:', data);
            }
            const buffers = buildBuffers(messages, name, data);
            try {
                if (!((_d = window.desktopApi) === null || _d === void 0 ? void 0 : _d.nobleBle)) {
                    throw new Error('Noble BLE write API not available');
                }
                for (let i = 0; i < buffers.length; i++) {
                    const buffer = buffers[i];
                    if (!buffer || typeof buffer.toString !== 'function') {
                        (_e = this.Log) === null || _e === void 0 ? void 0 : _e.error(`[Transport] Noble BLE buffer ${i + 1} is invalid:`, buffer);
                        throw new Error(`Buffer ${i + 1} is invalid`);
                    }
                    const hexString = buffer.toString('hex');
                    if (hexString.length === 0) {
                        (_f = this.Log) === null || _f === void 0 ? void 0 : _f.error(`[Transport] Noble BLE buffer ${i + 1} generated empty hex string`);
                        throw new Error(`Buffer ${i + 1} is empty`);
                    }
                    yield window.desktopApi.nobleBle.write(uuid, hexString);
                }
                const response = yield this.runPromise.promise;
                if (typeof response !== 'string') {
                    throw new Error('Returning data is not string.');
                }
                const jsonData = receiveOne(messages, response);
                return check.call(jsonData);
            }
            catch (e) {
                (_g = this.Log) === null || _g === void 0 ? void 0 : _g.error('[Transport] Noble BLE call error:', e);
                throw e;
            }
            finally {
                this.runPromise = null;
            }
        });
    }
    processNotificationPacket(deviceId, hexData) {
        try {
            if (typeof hexData !== 'string') {
                return { isComplete: false, error: 'Invalid hexData type' };
            }
            const cleanHexData = hexData.replace(/\s+/g, '');
            if (!/^[0-9A-Fa-f]*$/.test(cleanHexData)) {
                return { isComplete: false, error: 'Invalid hex data format' };
            }
            const hexMatch = cleanHexData.match(/.{1,2}/g);
            if (!hexMatch) {
                return { isComplete: false, error: 'Failed to parse hex data' };
            }
            const data = new Uint8Array(hexMatch.map(byte => parseInt(byte, 16)));
            const bufferState = this.dataBuffers.get(deviceId);
            if (!bufferState) {
                return { isComplete: false, error: 'No buffer state for device' };
            }
            if (hdShared.isHeaderChunk(data)) {
                const dataView = new DataView(data.buffer);
                bufferState.bufferLength = dataView.getInt32(5, false);
                bufferState.buffer = [...data.subarray(3)];
            }
            else {
                bufferState.buffer = bufferState.buffer.concat([...data]);
            }
            if (bufferState.buffer.length - transport.COMMON_HEADER_SIZE >= bufferState.bufferLength) {
                const completeBuffer = new Uint8Array(bufferState.buffer);
                bufferState.bufferLength = 0;
                bufferState.buffer = [];
                const hexString = Array.from(completeBuffer)
                    .map(b => b.toString(16).padStart(2, '0'))
                    .join('');
                return { isComplete: true, completePacket: hexString };
            }
            return { isComplete: false };
        }
        catch (error) {
            return { isComplete: false, error: `Packet processing error: ${error}` };
        }
    }
}

exports.ElectronBleTransport = ElectronBleTransport;
exports.WebUsbTransport = WebUsbTransport;
